(function() {
  const CLASS_HIDDEN_COUNTDOWN = 'countdown-hidden';
  const FORCE_REMOVE_COUNTDOWN_QP = 'force_remove_countdown';
  const initialLoad = function() {
    //Remove countdown elements
    Array.from(document.querySelectorAll('[data-countdown]')).forEach((elem) => {
      elem.parentElement.removeChild(elem);
    });

    // Show hidden pre countdown
    Array.from(document.getElementsByClassName(CLASS_HIDDEN_COUNTDOWN)).forEach((elem) => {
      elem.classList.remove(CLASS_HIDDEN_COUNTDOWN)
    });
  };

  const updateCounter = function (distance) {
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const secondsNumber = Math.floor((distance % (1000 * 60)) / 1000);
    const seconds = secondsNumber.toLocaleString(undefined, { minimumIntegerDigits: 2 });
    const endTime = [days, hours, minutes, seconds];
    endTime.forEach(function(value, index) {
      parent = document.getElementById(`hero_countdown_number_${index}`);
      if (parent) {
        parent.innerHTML = value;
      }
    });
  }

  const isForcedRemovedCountdown = () => {
    const params = new URLSearchParams(location.search);
    const forcedValue = params.get(FORCE_REMOVE_COUNTDOWN_QP);

    return (forcedValue === '1' || forcedValue === 'true');
  };

  const calculateDistance = (date) => {
    let now = Date.now();
    return date - now;
  }

  if (isForcedRemovedCountdown()) {
    initialLoad();
    return;
  }

  const date = document
    .querySelector("#countdown-conf")
    .getAttribute("data-time");
  const countDownDate = new Date(date).getTime();
  let distance = calculateDistance(countDownDate);

  if (distance < 0) {
    initialLoad();
  } else {
    // Update the count down every 1 second
    updateCounter(distance);
    const x = setInterval(function() {
      const distance = calculateDistance(countDownDate);
      if (distance < 0) {
        clearInterval(x);
        initialLoad();
      } else {
        updateCounter(distance)
      }
    }, 1000);
  }
})();
